<template>
  <div v-if="student && student.id" class="" @click="$emit('change', student)">
    <div>
      <div class="black--text" style="white-space: nowrap">{{ student.name }}</div>
      <div style="white-space: nowrap; color: #797979;">
        <span>{{ student.code_short || '--' }}</span>
      </div>
      <div style="white-space: nowrap; color: #797979;">
        <span>{{ student.dob | ddmmyyyy }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    student: Object,
    isError: Boolean
  },
  computed: {},
  async created() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
